import type { SyntheticEvent } from "react";
import { AssetsPng } from "../assets/png";
import { DefaultImageType } from "../configs/appConstants";

export function defaultImageLoad(
  event: SyntheticEvent<HTMLImageElement>,
  type: DefaultImageType,
  _imageCondition?: string,
) {
  let fallback: string;
  switch (type) {
    case DefaultImageType.UserProfile:
    case DefaultImageType.SideNavProfile:
    case DefaultImageType.DefaultProfile:
      fallback = AssetsPng.GenericUser;
      break;
    case DefaultImageType.CompanyProfile:
      fallback = AssetsPng.CompanyImage;
      break;
    case DefaultImageType.DefaultCompanyProfile:
      fallback = AssetsPng.DefaultCompanyImage;
      break;
    case DefaultImageType.DefaultChat:
      fallback = AssetsPng.DeFaultChatImage;
      break;
    default:
      return;
  }

  const image = event.currentTarget;
  const fallbackUrl = new URL(fallback, image.ownerDocument.baseURI).href;
  // React still calls onError if the fallback fails. Do not assign the same
  // source again: doing so starts another request and creates an error loop.
  if (image.src === fallbackUrl) return;
  image.src = fallbackUrl;
}
